const applicationKey = 'note-app-by-subash'

function getNotes() {
  let notes = JSON.parse(localStorage.getItem(applicationKey))
  if(notes){
    notes = notes.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.updatedOn) - new Date(a.updatedOn);
      });
  }
  return notes || []
}

function saveNote(note) {
    let notes = getNotes()
    notes = notes.filter(function(x){
        return x.id != note.id
    });
    notes.push(note)
    localStorage.setItem(applicationKey, JSON.stringify(notes))
}

function deleteNote(id) {
    let notes = getNotes();
    notes = notes.filter(function(x){
        return x.id != id
    });
    localStorage.setItem(applicationKey, JSON.stringify(notes))
}

function deleteAllNotes() {
    localStorage.setItem(applicationKey, JSON.stringify([]))
}

export { getNotes, deleteNote, saveNote, deleteAllNotes }
